import { useTranslation } from 'react-i18next';
import { SingleDatePickerField, SingleDatePickerFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

export const PreLaunchDateField = <T extends string = keyof typeof MarketplaceFormKeys>({
  name,
  required,
  ...restProps
}: Partial<SingleDatePickerFieldProps<T>>) => {
  const { t } = useTranslation();

  return (
    <SingleDatePickerField<T>
      help={t('Tooltip.preLaunchDateHelp')}
      title={t('Pre-launch Date')}
      required={required}
      optional={!required}
      disabledDays={{ before: new Date() }}
      name={name || (MarketplaceFormKeys.preLaunchDate as T)}
      {...restProps}
    />
  );
};
